import { Controller, useFormContext } from 'react-hook-form';
import { Autocomplete, FormInputText, InputLabel } from '@hopskipdrive/react-components';

import { useReportsQuery } from '../../../hooks/useReportsQuery';

import { useCategories } from './useCategories';

const id = 'categories-filter';

export const Categories = () => {
  const { staticFilters } = useReportsQuery();
  const { categories, isFetching, fetchCategories, hasFetched } = useCategories();
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const textContainsAll = /all/;
  const combinedOptions = [...(staticFilters?.categories || []), ...categories].map((option) => ({
    ...option,
    group: textContainsAll.test(option.value) ? 'predefined' : 'categories',
  }));

  return (
    <>
      <InputLabel htmlFor={id}>Categories</InputLabel>
      <Controller
        name="categories"
        control={control}
        defaultValue={[]}
        render={({ field: { value, onChange } }) => (
          <Autocomplete
            className={!!errors.categories ? 'hasError' : ''}
            value={value}
            id={id}
            data-testid={id}
            options={combinedOptions}
            isLoading={isFetching}
            multiple
            getOptionDisabled={(option) => {
              const currentValues = value.map((option) => ({
                ...option,
                group: textContainsAll.test(option.value) ? 'predefined' : 'categories',
              }));

              return getOptionDisabled(option, { value: currentValues });
            }}
            autoHighlight
            isOptionEqualToValue={(option, value) => categories.length === 0 || option.value === value.value}
            onOpen={() => !hasFetched && fetchCategories()}
            renderInput={(params) => (
              <FormInputText
                {...params}
                variant="outlined"
                error={!!errors.categories}
                helperText={errors.categories?.message as string}
              />
            )}
            onChange={(_, value) => onChange(value)}
          />
        )}
      />
    </>
  );
};

const getOptionDisabled = (option, { value = [] }: { value?: Array<{ value: string; group: string }> } = {}) => {
  const isApiOption = option.group === 'categories';
  const isPredefinedOption = option.group === 'predefined';

  if (isApiOption) {
    // Disable the entire 'predefined' group when any API option ('riders') is selected
    return value.some((selectedOption) => selectedOption.group === 'predefined');
  }
  if (isPredefinedOption) {
    // Disable all other predefined options when a predefined option is selected
    return value.some(
      (selectedOption) =>
        (selectedOption.group === 'predefined' && selectedOption.value !== option.value) ||
        selectedOption.group === 'categories'
    );
  }

  return false;
};
